import { format, parseISO } from 'date-fns';

// Group data by facility and occupation
export const transformData = (data) => {
  const facilities = {};

  data.forEach((entry) => {
    const { facility, occupation_name, period_start, duration } = entry;
    const formattedDate = format(parseISO(period_start), 'yyyy-MM-dd');

    if (!facilities[facility]) {
      facilities[facility] = {};
    }

    if (!facilities[facility][occupation_name]) {
      facilities[facility][occupation_name] = {};
    }

    facilities[facility][occupation_name][formattedDate] = duration;
  });

  return facilities;
};

// Get unique, sorted period_start dates
export const getSortedPeriodStartDates = (data) => {
  const allDates = data.map((entry) => entry.period_start);
  const uniqueDates = Array.from(new Set(allDates));
  return uniqueDates.sort((a, b) => (a < b ? 1 : -1));
};
